<template>
  <el-row>
    <el-col :span="4" :offset="1"  class="profile-sidebar">
      <el-menu :default-active="$router.currentRoute.path" router>
        <el-menu-item-group title="Thống kê">
          <el-menu-item :index="Paths.ADMIN_GENERAL_STATISTIC">
            <FAIcon icon="fas fa-chart-bar" /> Thống kê
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="Quản lý">
          <el-menu-item :index="Paths.ADMIN_DOCUMENTS"> <FAIcon icon="fas fa-copy" />Quản lý tài liệu </el-menu-item>
          <el-menu-item :index="Paths.ADMIN_USERS"> <FAIcon icon="fas fa-users" />Quản lý thành viên </el-menu-item>
          <el-menu-item :index="Paths.ADMIN_CONTENTS"> <FAIcon icon="fas fa-book-open" />Quản lý nội dung </el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </el-col>
    <el-col :span="17" :offset="1" class="dashboard-container">
      <router-view />
    </el-col>
  </el-row>
</template>

<script>
import isEnable from "../helpers/EnvironmentHelper"
import FAIcon from "@/components/common/FAIcon.vue"
import { Paths } from "@/routes/paths.js"

export default {
  name: "Dashboard",
  components: { FAIcon },
  data: function () {
    return {
      Paths,
    }
  },
  methods: {
    isEnable(key) {
      return isEnable.isEnable(key)
    },
  },
}
</script>
<style scoped>
.dashboard-container {
  background-color: #fff;
  padding: 20px;
}
</style>
